import React from 'react'

import { Box, Icon, Text } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import { useFormProvider } from 'modules/processes/components/ItemWizard/Providers/form'

import PreviewAttachments from '../../../../components/Preview/Attachments'
import PreviewDescription from '../../../../components/Preview/Description'
import PreviewTitle from '../../../../components/Preview/Title'

const Preview = () => {
  const { form } = useFormProvider()

  const uploadBankCertificate = form.get('data_collection_configuration').value
    .uploadBankCertificate

  return (
    <Box>
      <PreviewTitle />
      <PreviewDescription />
      <PreviewAttachments />

      <Box paddingTop="s16" paddingBottom="s8">
        <Text.Normal weight="semibold" color="grey1000">
          {i18n.t(
            'processes.process_settings.wizard.tasks.types.request_bank_account.preview.title'
          )}
        </Text.Normal>

        <Box paddingTop="s8">
          <Text.Normal>
            {i18n.t(
              'processes.process_settings.wizard.tasks.types.request_bank_account.preview.description'
            )}
          </Text.Normal>
        </Box>
      </Box>

      <Box padding="s24" gap="s24" background="grey200" borderRadius={{ all: 'abs016' }}>
        <Box flexDirection="row" justifyContent="spaceBetween" gap="s24">
          <Box width="s300" gap="s4">
            <Text.Normal size="200" weight="medium" color="grey1000">
              {i18n.t(
                'processes.process_settings.wizard.tasks.types.request_bank_account.preview.account_number_format'
              )}
            </Text.Normal>
            <Box
              background="grey000White"
              padding="s12"
              borderRadius={{ all: 'abs008' }}
              flexDirection="row"
              justifyContent="spaceBetween"
              alignItems="center"
              border={{ all: { width: 's1', color: 'grey400', style: 'solid' } }}
            >
              <Text.Normal color="grey800">
                {i18n.t(
                  'processes.process_settings.wizard.tasks.types.request_bank_account.preview.iban'
                )}
              </Text.Normal>
              <Icon.Small icon="caret-down" color="grey800" />
            </Box>
          </Box>
          <Box width="s300" gap="s4">
            <Text.Normal size="200" weight="medium" color="grey1000">
              {i18n.t(
                'processes.process_settings.wizard.tasks.types.request_bank_account.preview.iban'
              )}
            </Text.Normal>
            <Box
              background="grey000White"
              padding="s12"
              borderRadius={{ all: 'abs008' }}
              border={{ all: { width: 's1', color: 'grey400', style: 'solid' } }}
            >
              <Text.Normal color="grey600">
                {i18n.t(
                  'processes.process_settings.wizard.tasks.types.request_bank_account.preview.write_iban'
                )}
              </Text.Normal>
            </Box>
          </Box>
        </Box>
        <Box gap="s4">
          <Text.Normal size="200" weight="medium" color="grey1000">
            {i18n.t(
              'processes.process_settings.wizard.tasks.types.request_bank_account.preview.swift'
            )}
          </Text.Normal>
          <Box
            background="grey000White"
            padding="s12"
            borderRadius={{ all: 'abs008' }}
            border={{ all: { width: 's1', color: 'grey400', style: 'solid' } }}
          >
            <Text.Normal color="grey600">
              {i18n.t(
                'processes.process_settings.wizard.tasks.types.request_bank_account.preview.write_swift'
              )}
            </Text.Normal>
          </Box>
        </Box>
      </Box>

      {uploadBankCertificate && (
        <>
          <Box paddingTop="s24" paddingBottom="s12">
            <Box paddingBottom="s12">
              <Text.Normal weight="semibold" color="grey1000">
                {i18n.t(
                  'processes.process_settings.wizard.tasks.types.request_bank_account.preview.upload_certificate'
                )}
              </Text.Normal>
            </Box>

            <Box flexDirection="row">
              <Text.Normal>
                {i18n.t(
                  'processes.process_settings.wizard.tasks.types.request_bank_account.preview.id_bank.first'
                )}
              </Text.Normal>

              <Box paddingLeft="s4">
                <Text.Normal weight="semibold">
                  {i18n.t(
                    'processes.process_settings.wizard.tasks.types.request_bank_account.preview.id_bank.second'
                  )}
                </Text.Normal>
              </Box>
            </Box>

            <Text.Normal>
              {i18n.t(
                'processes.process_settings.wizard.tasks.types.request_bank_account.preview.store'
              )}
            </Text.Normal>
          </Box>

          <Box>
            <Box
              width="full"
              textAlign="center"
              paddingX="s12"
              borderRadius={{ all: 'abs006' }}
              border={{
                all: {
                  width: 's2',
                  style: 'dashed',
                  color: 'grey400',
                },
              }}
            >
              <Box flexDirection="column" alignItems="center" paddingBottom="s32">
                <>
                  <Box paddingTop="s32" paddingBottom="s12">
                    <Icon.Large icon="file-upload" color="grey700" />
                  </Box>
                  <Text.Normal weight="medium" size="300" color="grey800">
                    {i18n.t(
                      'processes.process_settings.wizard.tasks.types.upload_document.preview.upload.title'
                    )}
                  </Text.Normal>
                  <Text weight="normal" caps size="200" color="grey800">
                    {i18n.t(
                      'processes.process_settings.wizard.tasks.types.upload_document.preview.upload.format'
                    )}
                  </Text>
                </>
              </Box>
            </Box>
          </Box>
        </>
      )}
    </Box>
  )
}

export default Preview
